<template>
  <div class="root-box">
    <div class="query-container">
      <el-form size="small" :inline="true">
        <el-form-item label="关键词：">
          <el-input
            v-model="params.query"
            style="width: 240px"
            placeholder="请输入关键词"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="params.remark"
            style="width: 180px"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query()">查询</el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="primary" @click="openForm()">添加记录</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="list" stripe max-height="600">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="query" label="链接Query" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="link" label="链接" show-overflow-tooltip></el-table-column>
        <el-table-column prop="page" label="页面" show-overflow-tooltip></el-table-column>
        <el-table-column prop="validOn" label="有效期起"></el-table-column>
        <el-table-column prop="validOff" label="有效期止"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <el-dialog
      :visible.sync="visible"
      width="500px"
      title="新增微信小程序链接"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules" size="small">
        <el-form-item label="链接Query" prop="query">
          <el-input
            type="textarea"
            v-model="form.query"
            :rows="3"
            placeholder="请输入关键词"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" size="small" @click="save">保存</el-button>
        <el-button size="small" @click="visible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listWxMpLink, createWxMpLink } from "@/api/marketing";
export default {
  data() {
    return {
      list: [],
      params: {},
      visible: false,
      form: {},
      rules: {}
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      listWxMpLink(this.params).then((res) => {
        this.list = res.data || [];
      });
    },
    openForm() {
      this.visible = true;
      this.form = {};
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        createWxMpLink(this.form).then(() => {
          this.$message.success("添加成功");
          this.visible = false;
          this.query();
        });
      });
    }
  }
};
</script>

<style scoped>
.root-box {
  padding: 10px;
}

.query-container {
  margin-bottom: 20px;
}

.table {
  margin-bottom: 20px;
}
</style>
